export function waitForPassRatePromise(promiseName) {
  return new Promise(resolve => {
    const checkPromise = () => {
      if (window.passRatePromises && window.passRatePromises[promiseName]) {
        const result = window.passRatePromises[promiseName];
        delete window.passRatePromises[promiseName];
        resolve(result);
      } else {
        setTimeout(checkPromise, 500);
      }
    };
    checkPromise();
  });
}

export function waitForProcessTimePromise(promiseName) {
  return new Promise(resolve => {
    const checkPromise = () => {
      if (window.processTimePromises && window.processTimePromises[promiseName]) {
        const result = window.processTimePromises[promiseName];
        delete window.processTimePromises[promiseName];
        resolve(result);
      } else {
        setTimeout(checkPromise, 500);
      }
    };
    checkPromise();
  });
}
